
import React, { useEffect, useState } from 'react';
import { Layout, Box, Divider, ProgressBar } from '@shopify/polaris';
import { cardBackground } from '../../../assets';
import { star, cross, star_greyed, popup_star_outlined, popup_star_filled } from '../../../assets';
import Modal from 'react-modal';
import { useSelector } from 'react-redux';
import AppRating from '../interface/app_review_interface';
import { POSTAPPRATING } from '../../services/seller/endpoint';
import { CircularProgress } from '@mui/material'
import { getAppReview } from '../../services/seller/api';
import PropTypes from 'prop-types';  // Import PropTypes explicitly
import { captureGAEvent, gaPanelConfig } from '../../shared/helper';
import { clearEvents } from '../../utils/changeHeaderColor';






const Ratings = ({ appData }) => {
    const [page, setPage] = useState(0);

    const auth = useSelector((state: any) => state.auth);
    const authUrl = process.env.REACT_APP_REDIRECT_URL;
    const nextRedirectUrl = process.env.REACT_APP_WEB_BASE_URL;
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errorReviewMessage, setReviewErrorMessage] = useState('');
    const [appRatings, setAppRatings] = useState<AppRating[]>([]);
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isReviewLoading, setReviewLoading] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);
    const [hasMoreReviews, setHasMoreReviews] = useState(true);
    const [isSkeletonVisible, setIsSkeletonVisible] = useState(false);
    const [isMoreReviewsLoading, setMoreReviewsLoading] = useState(false);
    const [isInstallLoading, setInstallLoading] = useState(false);

    const handleLoadMore = () => {

        setPage((prevPage) => prevPage + 1);

    };
    const handleLogin = () => {
        localStorage.setItem('slug', appData.slug);
        const slugData = localStorage.getItem('slug');
        window.location.href = `${authUrl}/login?nextRedirectUrl=${nextRedirectUrl}`;
        // Handle login logic or redirect to login page

    }
    const sendGAEvent = (event: string) => {
       
        captureGAEvent(event, event);
    };
    const handleWriteReview = () => {
      
        clearEvents();
        gaPanelConfig.AppName = appData!.app_name;
        gaPanelConfig.AppStatus = appData.status;
        gaPanelConfig.AppSlug=appData.slug;
        gaPanelConfig.BtnText="Write a review";
       
        if (!auth.token) {
            // If not logged in, handle login action
            handleLogin();
            return;
        }

        // Check if the user is allowed to add a review
        if (appData.status === 'Installed' || appData.status === 'Uninstalled') {

            sendGAEvent('sras_app_review_button_click');
            // Your write a review logic here
            openModal();
        } else {
            // Show error message if the user is not allowed
            setReviewErrorMessage("You don’t have access, please install to add a review");
        }
    };

    const openModal = () => {
        setModalIsOpen(true);
        setRating(0);
    };

    const closeModal = () => {
        if (appRatings) {
            setModalIsOpen(false);
            window.location.reload();
        } else {
            console.log("");
        }
    };
    const handleStarClick = (index) => {
        setRating(index + 1);
    };

    const handleAddReview = async (appId: any, comment: string) => {
        setComment('');

        if (!auth.token) {
            // Display an error message if the token is null
            setErrorMessage('Please login');
            return;
        }
        setReviewLoading(true);
        try {
            // Call the API to submit the app rating
            const response = await fetch(POSTAPPRATING(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${auth.token}`
                },
                body: JSON.stringify({
                    app_id: appId,
                    rate: rating,
                    comment: comment,  // Replace with the actual comment
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to submit app rating');
            }

            // Handle the response as needed

            // Close the modal after successful submission
            setModalIsOpen(false);
            window.location.reload();
        } catch (error) {
            console.error('Error submitting app rating:', error);
            // Set the error message state
            setErrorMessage('Failed to submit app rating');
        } finally {
            // Set isReviewLoading back to false after the API call is complete
            setReviewLoading(false);
        }
    };
    const ratingBars = Object.entries(appData?.rating_bar || {});
    const Placeholder = ({ title, value }: { title: string; value: string }) => {
        return (
            <div style={{ paddingBottom: '10px' }}>
                <h1 style={{ fontSize: '18px', textTransform: 'capitalize', color: '#1D113E', fontWeight: '600' }}>{title}</h1>
                <span></span>
                <h1 style={{ fontSize: '22px', color: '#575757', textTransform: 'capitalize', fontFamily: 'sfprobold' }}>{value}</h1>
                <span></span>

            </div>
        );
    };
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }





    useEffect(() => {
        const fetchReviews = async () => {
            try {
                if (appData && appData.app_id) {
                    setMoreReviewsLoading(true);
                    const appRatingsResponse = await getAppReview(appData.app_id, page);

                    if (appRatingsResponse.data !== null) {
                        setAppRatings((prevAppRatings) => [...prevAppRatings, ...appRatingsResponse.data]);
                    } else {
                        console.error("Error: appRatingsResponse.data is null");
                        setHasMoreReviews(false);
                    }
                } else {
                    console.error("Error: appData or app_id is undefined");
                }
            } catch (error) {
                console.error("Error fetching reviews:", error);
            } finally {
                setIsSkeletonVisible(false);
                setMoreReviewsLoading(false);
            }
        };

        fetchReviews();
    }, [page]);
    return (


        <>
            <div className="hidden md:block">
                {/* <div style={{marginTop:"40px"}}>
           {appRatings.length===0 && <Divider />}
           </div> */}
                <div style={{ paddingTop: "60px", gap: "30px", }} className="container flex flex-col md:flex-row justify-center">

                    <div className="  lg-w-30p">

                        <div
                            className="flex flex-col justify-between"
                            style={{

                                // border: '1px solid #D3D3D3',
                                borderRadius: '25px',
                                opacity: 1,
                                backdropFilter: 'blur(14px)',
                                WebkitBackdropFilter: 'blur(14px)',
                                backgroundSize: '210% 170%',
                                backgroundPosition: 'center',
                                // width: "100%",
                                backgroundImage: `url(${cardBackground})`,
                                display: 'flex',

                                padding: '40px',
                                minHeight: '300px',
                                border: '1px solid #D3D3D3',



                            }}

                        >

                            <h2 className="" style={{ fontFamily: 'sfprobold', fontSize: '30px', color: '#0B0757' }}>
                                {appData.rating_count} Reviews
                            </h2>
                            {appData && appData.rating_count ? (
                                <>
                                    <p className="" style={{ fontFamily: 'sfproregular', fontSize: '18px', color: '#525167' }}>
                                        Overall rating
                                    </p>


                                    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '15px' }}>
                                        <span className="" style={{ marginRight: '20px', fontFamily: 'sfproregular', fontSize: '24px', color: '#727272' }}>
                                            ({(appData.overall_rating ?? 0).toFixed(1)})
                                        </span>
                                        {[...Array(5)].map((_, index) => (
                                            <img
                                                key={index}
                                                src={index < Math.floor(appData.overall_rating ?? 0) ? star : star_greyed}
                                                alt="Star Icon"
                                                style={{ height: '20px', width: '20px', marginRight: '10px' }}
                                            />
                                        ))}
                                    </div>



                                    <div style={{}}>
                                        {[5, 4, 3, 2, 1].map(rating => {
                                            const count = ratingBars.find(([barRating]) => +barRating === rating)?.[1] || 0;
                                            return (
                                                <div key={rating} className="tw-flex tw-gap-sm lg:tw-gap-md center-align" style={{ marginBottom: '15px' }}>
                                                    <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{rating}</span>
                                                    <span className="tw-w-5 tw-h-5 lg:tw-w-6 lg:tw-h-6 tw-shrink-0" aria-hidden="true">
                                                        <img style={{ width: "20px", height: "20px" }} src={star} alt="Feature Icon" />
                                                    </span>
                                                    <span className="tw-text-body-sm tw-text-fg-secondary tw-text-body-xl tw-text-body-bg"></span>
                                                    <ProgressBar progress={(count as number / appData.rating_count) * 100} tone="primary" size="small"></ProgressBar>
                                                    <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{count as number}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            ) : (
                                <div style={{}}>
                                    {[5, 4, 3, 2, 1].map(rating => {
                                        const count = ratingBars.find(([barRating]) => +barRating === rating)?.[1] || 0;
                                        return (
                                            <div key={rating} className="tw-flex tw-gap-sm lg:tw-gap-md center-align zero-rating" style={{ marginBottom: '15px' }}>
                                                <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{rating}</span>
                                                <span className="tw-w-5 tw-h-5 lg:tw-w-6 lg:tw-h-6 tw-shrink-0" aria-hidden="true">
                                                    <img style={{ width: "20px", height: "20px" }} src={star} alt="Feature Icon" />
                                                </span>
                                                <span className="tw-text-body-sm tw-text-fg-secondary tw-text-body-xl tw-text-body-bg"></span>
                                                <ProgressBar progress={(count as number / appData.rating_count) * 100} tone="primary" size="small"></ProgressBar>
                                                <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{count as number}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}


                            <div>
                                {/* Your other content */}
                                <div className="button-row" style={{ marginTop: '5px' }}>
                                    <button
                                        className={`review-button${isInstalled ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={handleWriteReview}
                                        disabled={isInstalled}
                                    >
                                        {auth.token ? 'Write a Review' : 'Login to Review'}
                                    </button>
                                    {errorReviewMessage && <p style={{ color: 'red', marginTop: '10px' }}>{errorReviewMessage}</p>}
                                </div>


                                {/* Modal */}
                                <div className='pop-Card'>
                                    <Modal
                                        isOpen={modalIsOpen}
                                        onRequestClose={closeModal}
                                        contentLabel="Example Modal"
                                        style={{
                                            content: {
                                                position: 'absolute',
                                                height: '420px',
                                                width: '400px',
                                                margin: 'auto', // This centers the modal horizontally
                                                marginTop: 'auto', // Adjust the top margin as needed
                                                borderRadius: '15px',
                                                backgroundImage: `url(${cardBackground})`,
                                                backgroundPosition: 'center',
                                                backgroundSize: '210% 170%',
                                                padding: '10px', // Add padding of 10px
                                            },
                                            overlay: {
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                zIndex: 9998,
                                            },
                                        }}
                                        shouldCloseOnOverlayClick={false}
                                    >


                                        <div style={{ paddingBottom: '30px' }}>
                                            <img
                                                src={cross}
                                                alt="image"
                                                className="absolute -translate-y-1/5 right-[15px] z-10"
                                                style={{ width: "33px", height: "auto", cursor: "pointer" }}
                                                onClick={() => setModalIsOpen(false)}
                                            // onMouseOver={(e) => (e.target as HTMLImageElement).style.transform = "scale(1.2)"}
                                            // onMouseOut={(e) => (e.target as HTMLImageElement).style.transform = "scale(1)"}
                                            />
                                        </div>



                                        <div className="modal-content" style={{ borderRadius: '25px', padding: '15px', display: 'flex', flexDirection: 'column', }}>
                                            <div style={{ paddingBottom: '25px' }}>
                                                <p style={{ fontFamily: 'sfprobold', fontSize: '25px', paddingBottom: '20px' }}>Thank you for your feedback!</p>
                                                <p style={{ fontSize: '20px', fontFamily: 'sfpromedium', paddingBottom: '20px' }}>Please rate your experience</p>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                                                    {[...Array(5)].map((_, index) => (
                                                        <img
                                                            key={index}
                                                            onClick={() => handleStarClick(index)}
                                                            src={index < rating ? popup_star_filled : popup_star_outlined}
                                                            alt="star"
                                                            style={{ cursor: 'pointer', height: '30px', width: '30px' }}
                                                        />
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Write a Review Section */}
                                            <input
                                                placeholder="Write your review..."
                                                onChange={(e) => setComment(e.target.value)}
                                                style={{
                                                    fontFamily: 'sfproregular',
                                                    fontSize: '20px',
                                                    height: '60px',
                                                    width: '-webkit-fill-available',
                                                    borderRadius: '15px',
                                                    padding: '10px',
                                                    boxSizing: 'border-box',
                                                    textAlign: 'start',
                                                    border: 'none', // Remove border color
                                                    outline: 'none', // Remove outline when focused
                                                }}
                                            />

                                            {errorMessage && <p style={{ color: 'red', marginTop: ' ' }}>{errorMessage}</p>}

                                            {/* Buttons */}
                                            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px' }}>
                                                <button className="review-button" onClick={() => handleAddReview(appData.app_id, comment)} disabled={rating === 0 || isInstallLoading} style={{ margin: '0 25px' }}>
                                                    {isReviewLoading ? (
                                                        <CircularProgress color="inherit" size={40} />
                                                    ) : (
                                                        'Submit'
                                                    )}
                                                </button>

                                            </div>


                                        </div>
                                    </Modal></div>


                            </div>



                        </div>
                    </div>

                    <div className="w-full md:w-2/3 lg:w-2/3">
                        <Box>

                            {/* <h2 className="" style={{ marginBottom: '10px', fontFamily: 'sfprobold', fontSize: '25px', color: '#0B0757' }}> What merchants think</h2> */}

                            {appData && appData.merchants_view === null ? (
                                <p className="" style={{ marginBottom: '25px', fontFamily: 'sfproregular', fontSize: '16px', color: '#5F5F5F' }}>
                                </p>
                            ) : (
                                <p className="" style={{ marginBottom: '25px', fontFamily: 'sfproregular', fontSize: '20px', color: '#5F5F5F' }}>
                                    {appData && appData.merchants_view ? capitalizeFirstLetter(appData.merchants_view) : ""}
                                </p>
                            )}


                            {appRatings.length > 0 && <Divider />}

                            <div>

                                {appRatings ? (
                                    appRatings.length > 0 ? (
                                        appRatings.map((rating) => (
                                            <div key={rating.id}>
                                                <p className="" style={{ paddingTop: '25px', paddingBottom: '20px', fontFamily: 'sfproregular', fontSize: '16px' }}>
                                                    {rating.comment ? `"${capitalizeFirstLetter(rating.comment)}"` : null}
                                                </p>
                                                <Placeholder title={rating.first_name + " " + rating.last_name} value="" />
                                                <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '15px', flexShrink: 0 }}>
                                                    {[...Array(5)].map((_, index) => (
                                                        <img
                                                            key={index}
                                                            src={index < Math.floor(rating.rate ?? 0) ? star : star_greyed}
                                                            alt="Star Icon"
                                                            style={{ height: '20px', width: '22px', paddingRight: '5px', }}
                                                        />
                                                    ))}
                                                </div>
                                                <Divider />

                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '100px' }}>
                                            <div>
                                                <p style={{ fontFamily: 'sfproregular', fontSize: '20px', color: '#0B0757' }}>No reviews available</p>
                                            </div>
                                        </div>
                                    )
                                ) : (
                                    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '100px' }}>
                                        <div>
                                            <p style={{ fontFamily: 'sfproregular', fontSize: '20px', color: '#0B0757' }}>No reviews available</p>
                                        </div>
                                    </div>
                                )}

                                {appRatings && appRatings.length > 3 && hasMoreReviews && (
                                    <div>
                                        {isMoreReviewsLoading ? (
                                            <button style={{ marginTop: '10px' }} className="review-button" disabled>
                                                <CircularProgress color="inherit" style={{ marginTop: '10px', justifyContent: 'center', alignItems: 'center' }} />
                                            </button>
                                        ) : (
                                            <button onClick={handleLoadMore} style={{ padding: '10px' }} className="review-button">
                                                Load More
                                            </button>
                                        )}
                                    </div>
                                )}

                            </div>
                        </Box>
                    </div>



                </div>
            </div>

            {/* Second div - Show on mobile view */}
            <div className="block md:hidden">
                <div style={{ paddingTop: "20px", }} className="container flex flex-col md:flex-row justify-between">

                    <div className="lg-w-30p">
                        <div
                            className="flex flex-col justify-between"
                            style={{
                                marginTop: "15px",
                                // border: '1px solid #D3D3D3',
                                borderRadius: '25px',
                                opacity: 1,
                                backdropFilter: 'blur(14px)',
                                WebkitBackdropFilter: 'blur(14px)',
                                backgroundSize: '210% 170%',
                                backgroundPosition: 'center',
                                // width: "100%",
                                backgroundImage: `url(${cardBackground})`,
                                display: 'flex',

                                padding: '40px',
                                minHeight: '300px',
                                border: '1px solid #D3D3D3',



                            }}

                        >

                            <h2 className="" style={{ fontFamily: 'sfprobold', fontSize: '30px', color: '#0B0757' }}>
                                {appData.rating_count} Reviews
                            </h2>
                            {appData && appData.rating_count ? (
                                <>
                                    <p className="" style={{ fontFamily: 'sfproregular', fontSize: '18px', color: '#525167' }}>
                                        Overall rating
                                    </p>


                                    <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '15px' }}>
                                        <span className="" style={{ marginRight: '20px', fontFamily: 'sfproregular', fontSize: '24px', color: '#727272' }}>
                                            ({(appData.overall_rating ?? 0).toFixed(1)})
                                        </span>
                                        {[...Array(5)].map((_, index) => (
                                            <img
                                                key={index}
                                                src={index < Math.floor(appData.overall_rating ?? 0) ? star : star_greyed}
                                                alt="Star Icon"
                                                style={{ height: '25px', width: '27px', marginRight: '10px' }}
                                            />
                                        ))}
                                    </div>
                                    <div style={{}}>
                                        {[5, 4, 3, 2, 1].map(rating => {
                                            const count = ratingBars.find(([barRating]) => +barRating === rating)?.[1] || 0;
                                            return (
                                                <div key={rating} className="tw-flex tw-gap-sm lg:tw-gap-md center-align" style={{ marginBottom: '15px' }}>
                                                    <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{rating}</span>
                                                    <span className="tw-w-5 tw-h-5 lg:tw-w-6 lg:tw-h-6 tw-shrink-0" aria-hidden="true">
                                                        <img style={{ width: "20px", height: "20px" }} src={star} alt="Feature Icon" />
                                                    </span>
                                                    <span className="tw-text-body-sm tw-text-fg-secondary tw-text-body-xl tw-text-body-bg"></span>
                                                    <ProgressBar progress={(count as number / appData.rating_count) * 100} tone="primary" size="small"></ProgressBar>
                                                    <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{count as number}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            ) : (
                                <div style={{}}>
                                    {[5, 4, 3, 2, 1].map(rating => {
                                        const count = ratingBars.find(([barRating]) => +barRating === rating)?.[1] || 0;
                                        return (
                                            <div key={rating} className="tw-flex tw-gap-sm lg:tw-gap-md center-align zero-rating" style={{ marginBottom: '15px' }}>
                                                <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{rating}</span>
                                                <span className="tw-w-5 tw-h-5 lg:tw-w-6 lg:tw-h-6 tw-shrink-0" aria-hidden="true">
                                                    <img style={{ width: "20px", height: "20px" }} src={star} alt="Feature Icon" />
                                                </span>
                                                <span className="tw-text-body-sm tw-text-fg-secondary tw-text-body-xl tw-text-body-bg"></span>
                                                <ProgressBar progress={(count as number / appData.rating_count) * 100} tone="primary" size="small"></ProgressBar>
                                                <span style={{ fontFamily: 'sfproregular', fontSize: '17px', }}>{count as number}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}


                            <div>
                                {/* Your other content */}
                                <div className="button-row" style={{ marginTop: '5px' }}>
                                    <button className="review-button" onClick={handleWriteReview} disabled={isInstalled}>
                                        {auth.token ? 'Write a Review' : 'Login to Review'}
                                    </button>
                                    {errorReviewMessage && <p style={{ color: 'red', marginTop: '10px' }}>{errorReviewMessage}</p>}
                                </div>

                                {/* Modal */}
                                <div className='pop-Card'>
                                    <Modal
                                        isOpen={modalIsOpen}
                                        onRequestClose={closeModal}
                                        contentLabel="Example Modal"
                                        style={{
                                            content: {
                                                position: 'absolute',
                                                height: '420px',
                                                width: '400px',
                                                margin: 'auto', // This centers the modal horizontally
                                                marginTop: 'auto', // Adjust the top margin as needed
                                                borderRadius: '15px',
                                                backgroundImage: `url(${cardBackground})`,
                                                backgroundPosition: 'center',
                                                backgroundSize: '210% 170%',
                                                padding: '10px', // Add padding of 10px
                                            },
                                            overlay: {
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                zIndex: 9998,
                                            },
                                        }}
                                        shouldCloseOnOverlayClick={false}
                                    >


                                        <div style={{ paddingBottom: '30px' }}>
                                            <img
                                                src={cross}
                                                alt="image"
                                                className="absolute -translate-y-1/5 right-[15px] z-10"
                                                style={{ width: "33px", height: "auto", cursor: "pointer" }}
                                                onClick={() => setModalIsOpen(false)}
                                            // onMouseOver={(e) => (e.target as HTMLImageElement).style.transform = "scale(1.2)"}
                                            // onMouseOut={(e) => (e.target as HTMLImageElement).style.transform = "scale(1)"}
                                            />
                                        </div>



                                        <div className="modal-content" style={{ borderRadius: '25px', padding: '15px', display: 'flex', flexDirection: 'column', }}>
                                            <div style={{ paddingBottom: '25px' }}>
                                                <p style={{ fontFamily: 'sfprobold', fontSize: '25px', paddingBottom: '20px' }}>Thank you for your feedback!</p>
                                                <p style={{ fontSize: '20px', fontFamily: 'sfpromedium', paddingBottom: '20px' }}>Please rate your experience</p>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
                                                    {[...Array(5)].map((_, index) => (
                                                        <img
                                                            key={index}
                                                            onClick={() => handleStarClick(index)}
                                                            src={index < rating ? popup_star_filled : popup_star_outlined}
                                                            alt="star"
                                                            style={{ cursor: 'pointer', height: '30px', width: '30px' }}
                                                        />
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Write a Review Section */}
                                            <input
                                                placeholder="Write your review..."
                                                onChange={(e) => setComment(e.target.value)}
                                                style={{
                                                    fontFamily: 'sfproregular',
                                                    fontSize: '20px',
                                                    height: '60px',
                                                    width: '-webkit-fill-available',
                                                    borderRadius: '15px',
                                                    padding: '10px',
                                                    boxSizing: 'border-box',
                                                    textAlign: 'start',
                                                    border: 'none', // Remove border color
                                                    outline: 'none', // Remove outline when focused
                                                }}
                                            />

                                            {errorMessage && <p style={{ color: 'red', marginTop: ' ' }}>{errorMessage}</p>}

                                            {/* Buttons */}
                                            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '20px' }}>
                                                <button className="review-button" onClick={() => handleAddReview(appData.app_id, comment)} disabled={rating === 0 || isInstallLoading} style={{ margin: '0 25px' }}>
                                                    {isReviewLoading ? (
                                                        <CircularProgress color="inherit" size={40} />
                                                    ) : (
                                                        'Submit'
                                                    )}
                                                </button>

                                            </div>


                                        </div>
                                    </Modal></div>


                            </div>



                        </div>
                    </div>

                    <div className="w-full md:w-2/3 lg:w-2/3">

                        <Box>
                            {/* <h2 className="" style={{ marginTop: '10px', fontFamily: 'sfprobold', fontSize: '25px', color: '#0B0757' }}> What merchants think</h2> */}

                            {appData && appData.merchants_view === null ? (
                                <p className="" style={{ marginBottom: '25px', fontFamily: 'sfproregular', fontSize: '16px', color: '#5F5F5F' }}>
                                </p>
                            ) : (
                                <p className="" style={{ marginBottom: '25px', fontFamily: 'sfproregular', fontSize: '20px', color: '#5F5F5F' }}>
                                    {appData && appData.merchants_view ? capitalizeFirstLetter(appData.merchants_view) : ""}
                                </p>
                            )}


                            {appRatings.length > 0 && <Divider />}

                            <div>

                                {appRatings ? (
                                    appRatings.length > 0 ? (
                                        appRatings.map((rating) => (
                                            <div key={rating.id}>
                                                <p className="" style={{ paddingTop: '10px', fontFamily: 'sfproregular', fontSize: '16px' }}>
                                                    {rating.comment ? `"${capitalizeFirstLetter(rating.comment)}"` : null}
                                                </p>
                                                <Placeholder title={rating.first_name + " " + rating.last_name} value="" />
                                                <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '15px', flexShrink: 0 }}>
                                                    {[...Array(5)].map((_, index) => (
                                                        <img
                                                            key={index}
                                                            src={index < Math.floor(rating.rate ?? 0) ? star : star_greyed}
                                                            alt="Star Icon"
                                                            style={{ height: '20px', width: '22px', paddingRight: '5px', }}
                                                        />
                                                    ))}
                                                </div>
                                                <Divider />

                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ display: 'flex', justifyContent: 'center', }}>
                                            {/* <div>
                                                <p style={{ fontFamily: 'sfproregular', fontSize: '20px', color: '#0B0757' }}>No reviews available</p>
                                            </div> */}
                                        </div>
                                    )
                                ) : (
                                    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '100px' }}>
                                        <div>
                                            <p style={{ fontFamily: 'sfproregular', fontSize: '20px', color: '#0B0757' }}>No reviews available</p>
                                        </div>
                                    </div>
                                )}

                                {appRatings && appRatings.length > 3 && hasMoreReviews && (
                                    <div>
                                        {isMoreReviewsLoading ? (
                                            <button style={{ marginTop: '10px' }} className="review-button" disabled>
                                                <CircularProgress color="inherit" style={{ marginTop: '10px', justifyContent: 'center', alignItems: 'center' }} />
                                            </button>
                                        ) : (
                                            <button onClick={handleLoadMore} style={{ padding: '10px' }} className="review-button">
                                                Load More
                                            </button>
                                        )}
                                    </div>
                                )}

                            </div>
                        </Box>
                    </div>



                </div>
            </div>
        </>


    );
};

Ratings.propTypes = {
    appData: PropTypes.shape({
        status: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
        app_id: PropTypes.string.isRequired,
        updated_at: PropTypes.string,
        list_of_categories: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })),
        rating_bar: PropTypes.string,
        overall_rating: PropTypes.string,
        rating_count: PropTypes.string,
        merchants_view: PropTypes.string,
        // Add other required properties here
    }).isRequired,
};



export default Ratings;
